import React from "react";
import intelligentLead from "../../assets/images/key-features/IL_M.svg";
import advanceReporting from "../../assets/images/key-features/AR_A.svg";
import automatedEmail from "../../assets/images/key-features/AE_S.svg";
import contactIntelliAi from "../../assets/images/key-features/contact-intelli.svg";
import dataEnrich from "../../assets/images/key-features/DE_M.svg";
import multiChannelMngt from "../../assets/images/key-features/MCCM.svg";
import realTimeActivity from "../../assets/images/key-features/real-time-activity.svg";
import smartLeadMng from "../../assets/images/key-features/smart-lead.svg";
import aipoweredsalestrig from "../../assets/images/key-features/ai-powered-sales.svg";
import seamlessInte from "../../assets/images/key-features/SI.svg";

const featureCards = [
  {
    img: intelligentLead,
    alt: "Hospitality-Centric Lead Management",
    title: "Hospitality-Centric Lead Management",
    desc: "Capture and manage corporate bookings, event inquiries, and travel agent leads efficiently.",
  },
  {
    img: advanceReporting,
    alt: "Reputation Management with AI Intelligence",
    title: "Reputation Management with AI Intelligence",
    desc: "Monitor and respond to reviews across platforms like TripAdvisor, Google, and OTA channels.",
  },
  {
    img: automatedEmail,
    alt: "Email & WhatsApp Sequencing",
    title: "Email & WhatsApp Sequencing",
    desc: "Automate follow-ups for group bookings, loyalty programs, and promotional offers",
  },
  {
    img: contactIntelliAi,
    alt: "Contact Intelligence + AI Enrichment",
    title: "Contact Intelligence + AI Enrichment",
    desc: "Access detailed profiles of travel agencies, event planners, and corporate clients.",
  },
  {
    img: dataEnrich,
    alt: "Automated Outreach with Generative AI",
    title: "Automated Outreach with Generative AI",
    desc: "Create personalized email and WhatsApp campaigns for follow-ups, offers, and loyalty with AI content suggestions",
  },
  {
    img: multiChannelMngt,
    alt: "Multi-Property Campaign Management",
    title: "Multi-Property Campaign Management",
    desc: "Run centralized campaigns across hotel chains or multiple locations",
  },
  {
    img: aipoweredsalestrig,
    alt: "AI powered Sales Trigger",
    title: "AI powered Sales Trigger",
    desc: "Get notified when target accounts show interest in similar venues, events, or hospitality services",
  },
  {
    img: seamlessInte,
    alt: "CRM & PMS Integration",
    title: "CRM & PMS Integration",
    desc: "Connect seamlessly with hotel CRMs and Property Management Systems for unified operations.",
  },
  {
    img: smartLeadMng,
    alt: "Smart Lead Management for Hospitality",
    title: "Smart Lead Management for Hospitality",
    desc: "Customizable forms for event RFPs, corporate bookings, and dining reservations.",
  },
  {
    img: realTimeActivity,
    alt: "Real-Time Activity Timeline",
    title: "Real-Time Activity Timeline",
    desc: "Track all guest and prospect touchpoints—from the first inquiry to post-stay feedback.",
  },
];

const FeatureGrid = () => {
  return (
    <section className="tw-py-20 lg:tw-py-28 tw-bg-slate-50/50 tw-border-t tw-border-solid tw-border-slate-100">
      <div className="tw-max-w-7xl tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8">

        {/* Section header */}
        <div className="tw-text-center tw-mb-16">
          <span className="tw-inline-flex tw-items-center tw-gap-2 tw-text-xs tw-font-bold tw-text-[#5D44FF] tw-uppercase tw-tracking-widest tw-mb-4 tw-bg-indigo-50 tw-px-4 tw-py-1.5 tw-rounded-full tw-border tw-border-solid tw-border-indigo-100">
            <span className="tw-w-1.5 tw-h-1.5 tw-rounded-full tw-bg-[#5D44FF] tw-inline-block" />
            What We Offer
          </span>
          <h2 className="tw-text-2xl sm:tw-text-3xl lg:tw-text-4xl tw-font-extrabold tw-text-slate-900 tw-leading-tight">
            Features That'll Make You Go <span className="tw-text-[#5D44FF]">WOW!</span>
          </h2>
        </div>

        {/* Cards */}
        <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-8">
          {featureCards.map((card, idx) => (
            <div
              key={idx}
              className="tw-relative tw-overflow-hidden tw-bg-white tw-border tw-border-solid tw-border-slate-100 tw-rounded-3xl tw-p-8 tw-shadow-sm hover:tw-shadow-xl hover:tw-scale-[1.03] tw-transition-all tw-duration-300 tw-text-left tw-flex tw-flex-col"
            >
              {/* Ghost watermark icon in background */}
              <div className="tw-absolute tw-bottom-[-12px] tw-right-[-12px] tw-w-28 tw-h-28 tw-opacity-[0.06] tw-pointer-events-none">
                <img
                  src={card.img}
                  alt=""
                  aria-hidden="true"
                  className="tw-w-full tw-h-full tw-object-contain"
                />
              </div>

              {/* Icon box — unified indigo color matching the icon tones */}
              <div
                className="tw-w-14 tw-h-14 tw-mb-6 tw-flex-shrink-0 tw-flex tw-items-center tw-justify-center tw-rounded-2xl"
                style={{
                  backgroundColor: "#EEF2FF",
                  border: "1.5px solid #C7D2FE",
                }}
              >
                <img
                  src={card.img}
                  alt={card.alt}
                  className="tw-w-7 tw-h-7 tw-object-contain"
                  loading="lazy"
                />
              </div>

              {/* Text */}
              <h3 className="tw-text-lg tw-font-bold tw-text-slate-800 tw-mb-3">
                {card.title}
              </h3>
              <p className="tw-text-sm tw-text-slate-500 tw-leading-relaxed tw-m-0 tw-flex-grow">
                {card.desc}
              </p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default FeatureGrid;
